import { styled as l } from "@mui/material/styles";
import { rootShouldForwardProp as e } from "@mui/material/styles/styled";
const c = l("svg", {
  shouldForwardProp: (o) => e(o) || o === "classes",
  name: "TrueSvgIcon",
  slot: "Root"
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
})(({ theme: o, ownerState: r }) => {
  function i() {
    if (r.color === "inherit" || !r.color) return "inherit";
    const [t, n = "main"] = r.color.split(".");
    return o.palette[t][n];
  }
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    transition: o.transitions.create("fill", {
      duration: o.transitions.duration.shorter
    }),
    fontSize: {
      inherit: "inherit",
      // TODO should be based on token.
      small: o.typography.pxToRem(20) || "1.25rem",
      medium: o.typography.pxToRem(24) || "1.5rem",
      large: o.typography.pxToRem(35) || "2.1875"
    }[r.fontSize] || `${r.fontSize}rem`,
    color: i()
  };
});
export {
  c as SvgIconRoot
};
//# sourceMappingURL=svg-icon.styles.js.map
